/* eslint-disable no-dupe-keys */
import { Box, FormControlLabel, Switch, Typography, Button, Tooltip, TextField, InputAdornment } from '@mui/material'
import React, { useState } from 'react'
import RadioBoxGroup from '../../../components/RadioButtons/RadioBoxGroup'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import ProjectTable from './ProjectTable'

const SecurityLogin = () => {

    const [activeTab, setActiveTab] = useState('singleTab');

    return (
        <>
            <Box    sx={{
                    overflowX: { xs: 'auto', sm: 'auto', md: 'visible' }, 
                    maxWidth: '100%',
                }}>
                {/* Tabs */}
                <Box    display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}>
                    <Button onClick={() => setActiveTab('singleTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'singleTab' ? '#0076FE' : '#fff', color: activeTab === 'singleTab' ? '#fff' : '#64748B', border: activeTab === 'singleTab' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600,    fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' }, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Single Sign-on</Button>
                    <Button onClick={() => setActiveTab('twoFactor')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'twoFactor' ? '#0076FE' : '#fff',
                        color: activeTab === 'twoFactor' ? '#fff' : '#64748B', border: activeTab === 'twoFactor' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600, fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Two-factor authentication
                    </Button>
                </Box>
                {/* Tab Panel Content */}
            </Box>



            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="singleTab">
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ m: '16px auto 32px', p: '14px 12px', border: '1px solid #0076FE', borderRadius: '8px', backgroundColor: '#0076FE0A' , flexWrap: 'wrap'}}>
                        <Typography display="flex" alignItems="center" sx={{ marginBottom: '10px' ,  gap: '10px', fontSize: '15px', fontWeight: '500', color: '#0076FE', fontFamily: 'Manrope' }}><img class="img-fluid" alt="Budget Icon" src="./assets/images/app-activity/projects/icons/lock-icon.svg" />
                            An enterprise plan is required to enable single sign-on. Upgrade to try it out today.</Typography>

                        <Button variant="contained" sx={{ marginBottom: '10px' ,  boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                            Upgrade Plan</Button>
                    </Box>

                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ m: '16px auto 32px', p: '16px', border: 'none', borderRadius: '8px', backgroundColor: '#FFF3DE' }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '10px', fontSize: '15px', fontWeight: '500', color: '#E69805', fontFamily: 'Manrope' }}>
                            <img class="img-fluid" alt="accordance icon" src="./assets/images/app-activity/icon2.png" />
                            In accordance with your agreement with timetrackr, you are responsible for compliance with all U.S. export and economic sanctions laws and regulations. You are prohibited from adding any Member located in any embargoed country or that is listed on the OFAC Specially Designated Nationals List or any other applicable sanctions list of the U.S. Government.</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{width: '100%'}}>  
                        <Box>
                            <Typography display="flex" alignItems="center" sx={{m:'0 auto 4px', gap: '12px', fontSize: '16px', color: '#A4A4A4', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                Single Sign-on
                                <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <Typography sx={{ maxWidth: '70%', fontSize: '12px', color: '#A4A4A4', fontWeight: '400', fontFamily: 'Manrope' }}>If you're using Microsoft Azure, Google Workspace, OneLogin, or another SAML-compatible provider, you can allow your team members to log in with their company credentials.</Typography>

                        </Box>
                        <RadioBoxGroup
                            options={['Off', 'No']}
                            defaultValue="Off"
                            row={true}
                        />
                    </Box>
                    <Box sx={{ m: '32px auto 0' }}>
                        <Typography sx={{ fontSize: '18px', fontWeight: '500', color: '#7D7D7D', fontFamily: 'Manrope' }}>Set up single sign-on</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#A4A4A4', fontFamily: 'Manrope', margin: '4px auto' }}>To configure Single Sign-On (SSO), please have your technical contact email support@timetrackr.com with your IdP SAML metadata file (usually named metadata.xml).</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#A4A4A4', fontFamily: 'Manrope', margin: '4px auto' }}>Our team will assist in completing the setup by providing the necessary configuration details.</Typography>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#A4A4A4', fontFamily: 'Manrope', margin: '4px auto' }}>More details are available in our support article about configuring single sign-on.</Typography>

                    </Box>
                </CustomTabPanel>


                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="twoFactor">
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{flexWrap: 'wrap'}}>
                        <Box sx={{ maxWidth: '80%'}}>
                            <Typography display="flex" alignItems="center" sx={{  marginBottom: '10px' ,  m:'0 auto 4px', gap: '12px', fontSize: '16px', color: '#A4A4A4', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                Require Two-factor Authentication
                                <Tooltip title="This setting allows you to require two-factor authentication for your team members" arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <Typography sx={{  marginBottom: '10px' ,  fontSize: '12px', color: '#A4A4A4', fontWeight: '400', fontFamily: 'Manrope' }}>Two-factor authentication adds an important layer of security by asking users to input a code sent to their phone when accessing their account from a device that isn’t recognized.</Typography>

                        </Box>
                        <RadioBoxGroup
                            options={['Not Required', 'Required']}
                            defaultValue="Not Required"
                            row={true}
                        />
                    </Box>
                </CustomTabPanel>

            </Box>


        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box p={2}>{children}</Box>;
};


export default SecurityLogin
